<div class="icons screen-element {{classes}}" [ngClass]="{'debug':debug}">

  @if (hasDHW()) {
    <div class="icon" [ngClass]="getDHWClass()"></div>
  }
  @if (hasWaterPressure()) {
    <div class="icon" [ngClass]="getPressureClass()"></div>
  }
  @if (timerActive()) {
    <div class="icon iconOperationTimeGrey" [ngClass]="{'debug':debug}"></div>
  }
  @if (hasHeating()) {
    <div class="icon" [ngClass]="getHeatingClass()"></div>
  }
  @if (greenIq()) {
    <div class="icon iconGreenIQGrey" [ngClass]="{'debug':debug}"></div>
  }

  @if (comfortModeActive()) {
    <div class="icon iconComfortModeGrey" [ngClass]="{'debug':debug}"></div>
  }
  @if (hasBurner()) {
    <div class="icon" [ngClass]="getBurnerClass()"></div>
  }

  @if (hasRadio()) {
    <div class="icon iconRadioConnectionGrey" [ngClass]="{'debug':debug}"></div>
  }
  @if (hasBattery()) {
    <div class="icon iconBatteryFullGrey" [ngClass]="{'debug':debug}"></div>
  }
  @if (isLocked()) {
    <div class="icon iconLockedGrey" [ngClass]="{'debug':debug}"></div>
  }
  @if (serviceDateExpired()) {
    <div class="icon iconCompetentPersonInstallerGrey" [ngClass]="{'debug':debug}"></div>
  }
</div>